module.exports = __webpack_public_path__ + "static/media/mms-logo.f0175121.png";